import React, { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import restApi from '../../../../api'
import LoadingIndicator from '../../../elements/LoadingIndicator'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import NotificationsIcon from '@mui/icons-material/Notifications'
import Brightness7Icon from '@mui/icons-material/Brightness7'

function ProfileAlerts (props) {
  useEffect(() => {
    props.apiActions.alertCounts({
      id: props.user.id
    })
  }, [])

  const renderAlertCounts = () => {
    const numOpenAlerts = props.clinicianAlertCountsApi.data.open
    const numClosedAlerts = props.clinicianAlertCountsApi.data.closed

    return (
      <Box>
        {!numOpenAlerts && !numClosedAlerts &&
          <Button size='small' variant='link' color='secondary' startIcon={<Brightness7Icon />} disabled>
            No alerts for {props.user.first_name}
          </Button>}

        {!!(numOpenAlerts || numClosedAlerts) &&
          <>
            <ButtonGroup variant='contained' size='small' sx={{ mb: 2 }} fullWidth aria-label='total alerts'>
              <Button sx={{ width: '50%', borderColor: 'unset !important' }} variant='outlined' disabled>
                <Box sx={{ color: theme => theme.palette.success.main }}>{numOpenAlerts} open</Box>
              </Button>
              <Button sx={{ width: '50%' }} color='secondary' disabled>
                <Box sx={{ color: theme => theme.palette.error.main }}>{numClosedAlerts} closed</Box>
              </Button>
            </ButtonGroup>

            <Button variant='text' href={`/alerts?user=${props.user.id}`} color='primary' startIcon={<NotificationsIcon />} sx={{ padding: 0 }}>
              View all alerts for {props.user.first_name}
            </Button>
          </>}
      </Box>
    )
  }

  const renderProfileAlerts = () => {
    return (
      <Card sx={props.cardStyle}>
        <CardContent>
          <Typography
            variant='h6'
            component='div'
            gutterBottom
            color='primary'
            marginBottom='1rem'
          >
            Alerts
          </Typography>

          <Box>
            {!props.clinicianAlertCountsApi.sync && <LoadingIndicator />}

            {!!(props.clinicianAlertCountsApi.sync) && renderAlertCounts()}
          </Box>
        </CardContent>
      </Card>
    )
  }

  return renderProfileAlerts()
}

function getPropsFromStore (state) {
  return {
    clinicianAlertCountsApi: state.api.alertCounts
  }
}

function getPropsFromActions (dispatch) {
  return {
    apiActions: bindActionCreators(restApi.actions, dispatch)
  }
}

export default connect(getPropsFromStore, getPropsFromActions)(ProfileAlerts)
